// src/pwa/InstallSlot.tsx: the one place the install card renders (docs/DECISIONS.md, "Install prompt"), mounted once
// in src/app/App.tsx after the screen, on every route. It renders only while a card is due (a trigger asked, and the
// viewer, the page, the browser and this device's limits all allow it; src/pwa/prompt.ts), and hands it to
// InstallCard, which the owner's design fills. Its wrapper takes no space of its own (display: contents) and carries
// data-trigger and data-platform for tests and styles. A card that throws renders nothing: it never takes a page down.
import { Component, type ComponentChildren } from "preact";
import { InstallCard } from "./InstallCard";
import { useInstallPrompt } from "./prompt";

class Quiet extends Component<{ children?: ComponentChildren }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }
  override componentDidCatch(error: unknown): void {
    console.error("install_card_error", error instanceof Error ? error.message : String(error));
  }
  override render() {
    return this.state.failed ? null : this.props.children;
  }
}

export function InstallSlot() {
  const { card } = useInstallPrompt();
  if (!card) return null;
  return (
    <Quiet>
      <div class="hb-install-slot" data-trigger={card.trigger} data-platform={card.platform} style={{ display: "contents" }}>
        <InstallCard card={card} />
      </div>
    </Quiet>
  );
}
